import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Collapse,
    Grid,
    IconButton,
    MenuItem,
    Select,
    Switch,
    TextField,
} from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withLang } from '../../util/lang';
import axios, { safeGet } from '../../axios-default';
import { easySnackbar } from '../../store/Noti/noti.actions';
import CountryCodeList from '../../util/country_code.json';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/Send';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import { styled } from '@material-ui/core/styles';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

class DoctorAppSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            doctor_app_setting_id: 0,
            email_address: '',
            first_name: '',
            last_name: '',
            country_id: 0,
            clinics: [],
            show_address: false,
            show_email: false,
            show_phone_no: false,
            show_whatsapp_no: false,
            approved: 1,
            countryList: [],
            provinceList: [],
            areaCodeList: [],
            isUpdating: false,
            admin_approval: ['SADMIN', 'ADMIN'].includes(JSON.parse(localStorage.getItem('role'))),
        };
    }

    async handleChangeData(stateName, value, clinic_index = undefined, schedule_index = undefined) {
        switch (stateName) {
            case 'new_clinic':
                let schedule = [];
                for (let i = 0; i < 7; i++) {
                    schedule[i] = {
                        doctor_app_setting_clinic_schedule_id: 0,
                        day: i,
                        day_off: false,
                        opening_time: '00:00:00',
                        closing_time: '23:30:00',
                    };
                }
                this.setState(({ clinics }) => ({
                    clinics: [
                        ...clinics,
                        {
                            doctor_app_setting_clinic_id: 0,
                            clinic_name: '',
                            clinic_email: '',
                            state_province_id: null,
                            city: '',
                            address: '',
                            post_code: '',
                            area_code: '',
                            phone_no: '',
                            whatsapp_no: '',
                            schedule,
                            show: true,
                        },
                    ],
                }));
                break;
            case 'country_id':
                const { state_province } = await safeGet(`res/state_province/${value}`);
                this.setState({ provinceList: state_province });
                this.state.clinics.forEach((c, i) => {
                    this.handleChangeData('state_province_id', 0, i);
                });
            default:
                if (typeof clinic_index != 'undefined') {
                    if (typeof schedule_index != 'undefined') {
                        this.setState(({ clinics }) => ({
                            clinics: [
                                ...clinics.slice(0, clinic_index),
                                {
                                    ...clinics[clinic_index],
                                    schedule: [
                                        ...clinics[clinic_index].schedule.slice(0, schedule_index),
                                        {
                                            ...clinics[clinic_index].schedule[schedule_index],
                                            [stateName]: value,
                                        },
                                        ...clinics[clinic_index].schedule.slice(schedule_index + 1),
                                    ],
                                },
                                ...clinics.slice(clinic_index + 1),
                            ],
                        }));
                    } else {
                        this.setState(({ clinics }) => ({
                            clinics: [
                                ...clinics.slice(0, clinic_index),
                                {
                                    ...clinics[clinic_index],
                                    [stateName]: value,
                                },
                                ...clinics.slice(clinic_index + 1),
                            ],
                        }));
                    }
                } else {
                    this.setState({ [stateName]: value });
                }
        }
    }

    handleDeleteClinic(index) {
        this.setState({
            clinics: [...this.state.clinics.slice(0, index), ...this.state.clinics.slice(index + 1)],
        });
    }

    handleOnOffData(stateName, value, clinic_index = undefined, schedule_index = undefined) {
        switch (stateName) {
            case 'show_address':
            case 'show_email':
            case 'show_phone_no':
            case 'show_whatsapp_no':
                this.setState({ [stateName]: value });
                break;
            case 'day_off':
                this.handleChangeData(stateName, value, clinic_index, schedule_index);
                break;
            default:
                this.props.showSnackbar(`Your ${stateName} must be shown to patients`, 'error');
                break;
        }
    }

    displayDay(index) {
        var weekdays = ['Sunday & Public Holiday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return weekdays[index];
    }

    async handleSaveData() {
        // validation
        if (
            this.state.email_address.trim() != '' &&
            !this.state.email_address.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
        ) {
            this.props.showSnackbar('Invalid email', 'error');
            return;
        }
        if (this.state.first_name.trim() == '') {
            this.props.showSnackbar('Invalid first name', 'error');
            return;
        }
        if (this.state.last_name.trim() == '') {
            this.props.showSnackbar('Invalid last name', 'error');
            return;
        }
        if (this.state.country_id == 0) {
            this.props.showSnackbar('Invalid country', 'error');
            return;
        }

        if (
            this.state.clinics.some((c, i) => {
                if (c.clinic_name.trim() == '') {
                    this.props.showSnackbar('Invalid clinic name', 'error');
                    this.handleChangeData('show', true, i);
                    return true;
                }
                if (this.state.show_email && c.clinic_email.trim() == '') {
                    this.props.showSnackbar('Cannot display empty email', 'error');
                    this.handleChangeData('show', true, i);
                    return true;
                }
                if (this.state.provinceList.length && c.state_province_id == 0) {
                    this.props.showSnackbar('Invalid state / province', 'error');
                    this.handleChangeData('show', true, i);
                    return true;
                }
                if (c.city.trim() == '') {
                    this.props.showSnackbar('Invalid city', 'error');
                    this.handleChangeData('show', true, i);
                    return true;
                }
                if (this.state.show_address && (c.address.trim() == '' || c.post_code.trim() == '')) {
                    this.props.showSnackbar('Cannot display empty address / postal code', 'error');
                    this.handleChangeData('show', true, i);
                    return true;
                }
                if (this.state.show_phone_no && (c.area_code.trim() == '' || c.phone_no.trim() == '')) {
                    this.props.showSnackbar('Cannot display empty area code / phone number', 'error');
                    this.handleChangeData('show', true, i);
                    return true;
                }
                if (this.state.show_whatsapp_no && c.whatsapp_no.trim() == '') {
                    this.props.showSnackbar('Cannot display empty Whatsapp number', 'error');
                    this.handleChangeData('show', true, i);
                    return true;
                }
            })
        ) {
            return;
        }

        this.setState({ isUpdating: true });
        let profile = {
            doctor_app_setting_id: this.state.doctor_app_setting_id,
            email_address: this.state.email_address,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            country_id: this.state.country_id,
            show_address: this.state.show_address,
            show_email: this.state.show_email,
            show_phone_no: this.state.show_phone_no,
            show_whatsapp_no: this.state.show_whatsapp_no,
            clinics: this.state.clinics,
        };

        let { data } = await axios.post(`/mobile_app/doctor/app_setting/${this.props.user_id}`, profile);
        if (data && data.success) {
            this.props.showSnackbar('Updated successfully', 'success');
            this.setState(data.doctorAppSetting);
        } else {
            this.props.showSnackbar(data.message, 'error');
        }
        this.setState({ isUpdating: false });
    }

    async handleApproveData() {
        this.setState({ isUpdating: true });
        let { data } = await axios.post(`/mobile_app/doctor/approve_app_setting/${this.props.user_id}`);
        if (data && data.success) {
            this.props.showSnackbar('Approved successfully', 'success');
            this.props.history.push(`/appSettingApproval`);
        } else {
            this.props.showSnackbar(data.message, 'error');
        }
        this.setState({ isUpdating: false });
    }

    async handleRejectData() {
        this.setState({ isUpdating: true });
        let { data } = await axios.post(`/mobile_app/doctor/reject_app_setting/${this.props.user_id}`);
        if (data && data.success) {
            this.props.showSnackbar('Rejected successfully', 'success');
            this.props.history.push(`/appSettingApproval`);
        } else {
            this.props.showSnackbar(data.message, 'error');
        }
        this.setState({ isUpdating: false });
    }

    async componentDidMount() {
        const { doctorAppSetting } = await safeGet(`mobile_app/doctor/app_setting/${this.props.user_id}`);
        this.setState(doctorAppSetting);

        let code = '',
            code_list = [];
        CountryCodeList.filter((v) => v.dial_code != null && v.dial_code.trim() != '')
            .sort((a, b) => parseInt(a.dial_code.replace(/ |\+/g, '')) - parseInt(b.dial_code.replace(/ |\+/g, '')))
            .map((v) => {
                let dial_code = v.dial_code.replace(/ /g, '');
                if (dial_code != code) {
                    code_list.push(dial_code);
                    code = dial_code;
                }
            });
        const { country_list } = await safeGet(`mobile_app/doctor/country`);
        const { state_province } = await safeGet(`res/state_province/${this.state.country_id}`);
        this.setState({ areaCodeList: code_list, countryList: country_list, provinceList: state_province });
    }

    render() {
        const TimeSlot = [];
        for (let hr = 0; hr < 24; hr++) {
            let ts = hr.toString().padStart(2, '0');
            TimeSlot.push(ts + ':00');
            TimeSlot.push(ts + ':30');
        }

        return (
            <Grid container style={{ padding: '16px 24px 24px' }}>
                <Grid item xs={12} style={{ color: 'red' }}>
                    This page is under testing currently. Please do not input or update any information until further
                    notice. Thank you for your kind attention.
                </Grid>
                <Grid item xs={12}>
                    Here below you can share your contact details on “TrioClear Aligner Mobile App” with your TrioClear
                    patients, and potential patients under our “Find your doctor” function, subject your region
                    availability.
                </Grid>
                <Grid item xs={12}>
                    <h1>Profile</h1>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12} sm={3} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Email:
                        </Grid>
                        <Grid item xs={12} sm={9} style={{ padding: '0px 10px' }}>
                            <TextField
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                autoFocus
                                value={this.state.email_address ?? ''}
                                onChange={(event) => this.handleChangeData('email_address', event.target.value)}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            />
                        </Grid>

                        <Grid item xs={6} sm={3} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            First name:
                        </Grid>
                        <Grid item xs={6} sm={3} style={{ padding: '0px 10px' }}>
                            <TextField
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                value={this.state.first_name ?? ''}
                                onChange={(event) => this.handleChangeData('first_name', event.target.value)}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            />
                        </Grid>

                        <Grid item xs={6} sm={3} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Last name:
                        </Grid>
                        <Grid item xs={6} sm={3} style={{ padding: '0px 10px' }}>
                            <TextField
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                value={this.state.last_name ?? ''}
                                onChange={(event) => this.handleChangeData('last_name', event.target.value)}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Country:
                        </Grid>
                        <Grid item xs={12} sm={9} style={{ padding: '0px 10px' }}>
                            <Select
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                value={this.state.country_id ?? 0}
                                onChange={(event) => this.handleChangeData('country_id', event.target.value)}
                                style={{ marginTop: '8px', marginBottom: '4px' }}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            >
                                <MenuItem value={0} key={0}></MenuItem>
                                {this.state.countryList.map((v) => (
                                    <MenuItem value={v.country_id} key={v.country_id}>
                                        {v.country_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <h1>Clinics</h1>
                </Grid>
                <Grid item xs={12}>
                    {this.state.clinics.length
                        ? this.state.clinics.map((c, i) => (
                              <Card>
                                  <CardHeader
                                      title={
                                          <div>
                                              {this.state.admin_approval ? (
                                                  ''
                                              ) : (
                                                  <IconButton
                                                      style={{ color: 'red' }}
                                                      onClick={() => this.handleDeleteClinic(i)}
                                                      disabled={this.state.isUpdating}
                                                  >
                                                      <DeleteIcon />
                                                  </IconButton>
                                              )}
                                              {c.clinic_name == '' && c.doctor_app_setting_clinic_id == 0
                                                  ? 'New Clinic'
                                                  : c.clinic_name}
                                          </div>
                                      }
                                      action={
                                          <ExpandMore
                                              expand={c.show}
                                              onClick={() => this.handleChangeData('show', !c.show, i)}
                                              aria-expanded={c.show}
                                              aria-label="show clinic detail"
                                          >
                                              <ExpandMoreIcon />
                                          </ExpandMore>
                                      }
                                  />
                                  <Collapse in={c.show}>
                                      <CardContent>
                                          <Grid container>
                                              <Grid
                                                  item
                                                  xs={12}
                                                  sm={3}
                                                  style={{ paddingTop: '10px', fontWeight: 'bold' }}
                                              >
                                                  Clinic Name:
                                              </Grid>
                                              <Grid item xs={12} sm={9} style={{ padding: '0px 10px' }}>
                                                  <TextField
                                                      margin="dense"
                                                      variant="outlined"
                                                      fullWidth
                                                      autoFocus
                                                      value={c.clinic_name ?? ''}
                                                      onChange={(event) =>
                                                          this.handleChangeData('clinic_name', event.target.value, i)
                                                      }
                                                      disabled={this.state.admin_approval || this.state.isUpdating}
                                                  />
                                              </Grid>

                                              <Grid
                                                  item
                                                  xs={12}
                                                  sm={3}
                                                  style={{ paddingTop: '10px', fontWeight: 'bold' }}
                                              >
                                                  Clinic Email:
                                              </Grid>
                                              <Grid item xs={12} sm={9} style={{ padding: '0px 10px' }}>
                                                  <TextField
                                                      margin="dense"
                                                      variant="outlined"
                                                      fullWidth
                                                      value={c.clinic_email ?? ''}
                                                      onChange={(event) =>
                                                          this.handleChangeData('clinic_email', event.target.value, i)
                                                      }
                                                      disabled={this.state.admin_approval || this.state.isUpdating}
                                                  />
                                              </Grid>

                                              <Grid
                                                  item
                                                  xs={12}
                                                  sm={3}
                                                  style={{ paddingTop: '10px', fontWeight: 'bold' }}
                                              >
                                                  State / Province:
                                              </Grid>
                                              <Grid item xs={12} sm={9} style={{ padding: '0px 10px' }}>
                                                  <Select
                                                      margin="dense"
                                                      variant="outlined"
                                                      fullWidth
                                                      value={c.state_province_id ?? 0}
                                                      onChange={(event) =>
                                                          this.handleChangeData(
                                                              'state_province_id',
                                                              event.target.value,
                                                              i
                                                          )
                                                      }
                                                      style={{ marginTop: '8px', marginBottom: '4px' }}
                                                      disabled={this.state.admin_approval || this.state.isUpdating}
                                                  >
                                                      <MenuItem value={0} key={0}></MenuItem>
                                                      {this.state.provinceList.map((v) => (
                                                          <MenuItem
                                                              value={v.state_province_id}
                                                              key={v.state_province_id}
                                                          >
                                                              {v.name}
                                                          </MenuItem>
                                                      ))}
                                                  </Select>
                                              </Grid>

                                              <Grid
                                                  item
                                                  xs={6}
                                                  sm={3}
                                                  style={{ paddingTop: '10px', fontWeight: 'bold' }}
                                              >
                                                  City:
                                              </Grid>
                                              <Grid item xs={6} sm={3} style={{ padding: '0px 10px' }}>
                                                  <TextField
                                                      margin="dense"
                                                      variant="outlined"
                                                      fullWidth
                                                      value={c.city ?? ''}
                                                      onChange={(event) =>
                                                          this.handleChangeData('city', event.target.value, i)
                                                      }
                                                      disabled={this.state.admin_approval || this.state.isUpdating}
                                                  />
                                              </Grid>

                                              <Grid
                                                  item
                                                  xs={6}
                                                  sm={3}
                                                  style={{ paddingTop: '10px', fontWeight: 'bold' }}
                                              >
                                                  Postal code:
                                              </Grid>
                                              <Grid item xs={6} sm={3} style={{ padding: '0px 10px' }}>
                                                  <TextField
                                                      margin="dense"
                                                      variant="outlined"
                                                      fullWidth
                                                      value={c.post_code ?? ''}
                                                      onChange={(event) =>
                                                          this.handleChangeData('post_code', event.target.value, i)
                                                      }
                                                      disabled={this.state.admin_approval || this.state.isUpdating}
                                                  />
                                              </Grid>

                                              <Grid
                                                  item
                                                  xs={12}
                                                  sm={3}
                                                  style={{ paddingTop: '10px', fontWeight: 'bold' }}
                                              >
                                                  Address:
                                              </Grid>
                                              <Grid item xs={12} sm={9} style={{ padding: '0px 10px' }}>
                                                  <TextField
                                                      margin="dense"
                                                      variant="outlined"
                                                      fullWidth
                                                      value={c.address ?? ''}
                                                      onChange={(event) =>
                                                          this.handleChangeData('address', event.target.value, i)
                                                      }
                                                      disabled={this.state.admin_approval || this.state.isUpdating}
                                                  />
                                              </Grid>

                                              <Grid
                                                  item
                                                  xs={12}
                                                  sm={3}
                                                  style={{ paddingTop: '10px', fontWeight: 'bold' }}
                                              >
                                                  Phone:
                                              </Grid>
                                              <Grid item xs={4} sm={3} style={{ padding: '0px 10px' }}>
                                                  <Select
                                                      margin="dense"
                                                      variant="outlined"
                                                      fullWidth
                                                      value={c.area_code ?? ''}
                                                      onChange={(event) =>
                                                          this.handleChangeData('area_code', event.target.value, i)
                                                      }
                                                      style={{ marginTop: '8px', marginBottom: '4px' }}
                                                      disabled={this.state.admin_approval || this.state.isUpdating}
                                                  >
                                                      <MenuItem value="" key=""></MenuItem>
                                                      {this.state.areaCodeList.map((v) => (
                                                          <MenuItem value={v} key={v}>
                                                              {v}
                                                          </MenuItem>
                                                      ))}
                                                  </Select>
                                              </Grid>
                                              <Grid item xs={8} sm={6} style={{ padding: '0px 10px' }}>
                                                  <TextField
                                                      margin="dense"
                                                      variant="outlined"
                                                      fullWidth
                                                      value={c.phone_no ?? ''}
                                                      onChange={(event) =>
                                                          this.handleChangeData('phone_no', event.target.value, i)
                                                      }
                                                      disabled={this.state.admin_approval || this.state.isUpdating}
                                                  />
                                              </Grid>

                                              <Grid
                                                  item
                                                  xs={6}
                                                  sm={3}
                                                  style={{ paddingTop: '10px', fontWeight: 'bold' }}
                                              >
                                                  Whatsapp:
                                              </Grid>
                                              <Grid item xs={6} sm={3} style={{ padding: '0px 10px' }}>
                                                  <TextField
                                                      margin="dense"
                                                      variant="outlined"
                                                      fullWidth
                                                      value={c.whatsapp_no ?? ''}
                                                      onChange={(event) =>
                                                          this.handleChangeData('whatsapp_no', event.target.value, i)
                                                      }
                                                      disabled={this.state.admin_approval || this.state.isUpdating}
                                                  />
                                              </Grid>

                                              <Grid item xs={12} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                                                  Schedule:
                                              </Grid>
                                              {c.schedule.map((s) => (
                                                  <Grid
                                                      item
                                                      xs={12}
                                                      sm={6}
                                                      md={4}
                                                      lg={3}
                                                      style={{ padding: '0px 10px' }}
                                                  >
                                                      {this.displayDay(s.day)}:
                                                      <Switch
                                                          checked={!s.day_off}
                                                          onChange={(event) =>
                                                              this.handleOnOffData(
                                                                  'day_off',
                                                                  !event.target.checked,
                                                                  i,
                                                                  s.day
                                                              )
                                                          }
                                                          disabled={this.state.admin_approval || this.state.isUpdating}
                                                      />
                                                      <br />
                                                      {s.day_off ? (
                                                          'Day Off'
                                                      ) : (
                                                          <>
                                                              <Select
                                                                  margin="dense"
                                                                  variant="outlined"
                                                                  value={s.opening_time ?? '00:00:00'}
                                                                  onChange={(event) =>
                                                                      this.handleChangeData(
                                                                          'opening_time',
                                                                          event.target.value,
                                                                          i,
                                                                          s.day
                                                                      )
                                                                  }
                                                                  style={{ marginTop: '8px', marginBottom: '4px' }}
                                                                  disabled={
                                                                      this.state.admin_approval || this.state.isUpdating
                                                                  }
                                                              >
                                                                  {TimeSlot.map((v) => (
                                                                      <MenuItem value={v + ':00'} key={v}>
                                                                          {v}
                                                                      </MenuItem>
                                                                  ))}
                                                              </Select>
                                                              &nbsp;to&nbsp;
                                                              <Select
                                                                  margin="dense"
                                                                  variant="outlined"
                                                                  value={s.closing_time ?? '00:00:00'}
                                                                  onChange={(event) =>
                                                                      this.handleChangeData(
                                                                          'closing_time',
                                                                          event.target.value,
                                                                          i,
                                                                          s.day
                                                                      )
                                                                  }
                                                                  style={{ marginTop: '8px', marginBottom: '4px' }}
                                                                  disabled={
                                                                      this.state.admin_approval || this.state.isUpdating
                                                                  }
                                                              >
                                                                  {TimeSlot.map((v) => (
                                                                      <MenuItem value={v + ':00'} key={v}>
                                                                          {v}
                                                                      </MenuItem>
                                                                  ))}
                                                              </Select>
                                                          </>
                                                      )}
                                                  </Grid>
                                              ))}
                                          </Grid>
                                      </CardContent>
                                  </Collapse>
                              </Card>
                          ))
                        : ''}
                </Grid>

                {!this.state.admin_approval ? (
                    <Grid item xs={3}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => this.handleChangeData('new_clinic', true, this.state.clinics.length)}
                            style={{ backgroundColor: '#473a69' }}
                            disabled={this.state.isUpdating}
                        >
                            {
                                <div style={{ color: 'white' }}>
                                    <AddIcon style={{ margin: '0px 8px', verticalAlign: 'middle', color: 'white' }} />
                                    Add clinic
                                </div>
                            }
                        </Button>
                    </Grid>
                ) : (
                    ''
                )}

                <Grid item xs={12}>
                    <h1>Options</h1>
                </Grid>
                <Grid item xs={12}>
                    <Grid container style={{ marginTop: '10px' }}>
                        <Grid item xs={4} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Name
                        </Grid>
                        <Grid item xs={2}>
                            <Switch
                                checked
                                onChange={(event) => this.handleOnOffData('show_name', event.target.checked)}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            />
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Compulsory
                        </Grid>

                        <Grid item xs={4} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Country
                        </Grid>
                        <Grid item xs={2}>
                            <Switch
                                checked
                                onChange={(event) => this.handleOnOffData('show_country', event.target.checked)}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            />
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Compulsory
                        </Grid>

                        <Grid item xs={4} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            City
                        </Grid>
                        <Grid item xs={2}>
                            <Switch
                                checked
                                onChange={(event) => this.handleOnOffData('show_city', event.target.checked)}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            />
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Compulsory
                        </Grid>

                        <Grid item xs={4} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Address & Postal code
                        </Grid>
                        <Grid item xs={2}>
                            <Switch
                                checked={this.state.show_address}
                                onChange={(event) => this.handleOnOffData('show_address', event.target.checked)}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            />
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            {this.state.show_address ? 'Shown to patient' : 'Hidden from patient'}
                        </Grid>

                        <Grid item xs={4} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Email
                        </Grid>
                        <Grid item xs={2}>
                            <Switch
                                checked={this.state.show_email}
                                onChange={(event) => this.handleOnOffData('show_email', event.target.checked)}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            />
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            {this.state.show_email ? 'Shown to patient' : 'Hidden from patient'}
                        </Grid>

                        <Grid item xs={4} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Phone
                        </Grid>
                        <Grid item xs={2}>
                            <Switch
                                checked={this.state.show_phone_no}
                                onChange={(event) => this.handleOnOffData('show_phone_no', event.target.checked)}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            />
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            {this.state.show_phone_no ? 'Shown to patient' : 'Hidden from patient'}
                        </Grid>

                        <Grid item xs={4} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            Whatsapp
                        </Grid>
                        <Grid item xs={2}>
                            <Switch
                                checked={this.state.show_whatsapp_no}
                                onChange={(event) => this.handleOnOffData('show_whatsapp_no', event.target.checked)}
                                disabled={this.state.admin_approval || this.state.isUpdating}
                            />
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: '10px', fontWeight: 'bold' }}>
                            {this.state.show_whatsapp_no ? 'Shown to patient' : 'Hidden from patient'}
                        </Grid>
                    </Grid>
                </Grid>

                {this.state.admin_approval ? (
                    this.state.approved == 0 ? (
                        <>
                            <Grid item xs={3}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={this.handleApproveData.bind(this)}
                                    style={{ backgroundColor: '#473a69' }}
                                    disabled={this.state.isUpdating}
                                >
                                    {this.state.isUpdating ? (
                                        <CircularProgress style={{ color: 'white' }} />
                                    ) : (
                                        <div style={{ color: 'white' }}>
                                            Approve
                                            <SendIcon
                                                style={{ margin: '0px 8px', verticalAlign: 'middle', color: 'white' }}
                                            />
                                        </div>
                                    )}
                                </Button>
                            </Grid>
                            <Grid item xs={3}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={this.handleRejectData.bind(this)}
                                    style={{ backgroundColor: 'red' }}
                                    disabled={this.state.isUpdating}
                                >
                                    {this.state.isUpdating ? (
                                        <CircularProgress style={{ color: 'white' }} />
                                    ) : (
                                        <div style={{ color: 'white' }}>
                                            Reject
                                            <NotInterestedIcon
                                                style={{ margin: '0px 8px', verticalAlign: 'middle', color: 'white' }}
                                            />
                                        </div>
                                    )}
                                </Button>
                            </Grid>
                        </>
                    ) : (
                        ''
                    )
                ) : (
                    <>
                        <Grid item xs={3}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={this.handleSaveData.bind(this)}
                                style={{ backgroundColor: '#473a69' }}
                                disabled={this.state.isUpdating}
                            >
                                {this.state.isUpdating ? (
                                    <CircularProgress style={{ color: 'white' }} />
                                ) : (
                                    <div style={{ color: 'white' }}>
                                        {this.get(':const.update')}
                                        <SendIcon
                                            style={{ margin: '0px 8px', verticalAlign: 'middle', color: 'white' }}
                                        />
                                    </div>
                                )}
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            By clicking “Update” button means that you agree to the Terms & Conditions, and Privacy
                            Policy of TrioClear Aligner Mobile App.
                        </Grid>
                    </>
                )}
            </Grid>
        );
    }
}

const mapStateToProps = (store) => ({
    lang: store.lang,
});

const mapDispatchToProps = (dispatch) => ({
    showSnackbar: (message, variant, queue = false) => dispatch(easySnackbar(message, variant, queue)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLang(DoctorAppSetting, 'DoctorAppSetting')));
